const runtimeErrorEndpointEnv = process.env.REACT_APP_RUNTIME_ERROR_ENDPOINT;
const RUNTIME_ERROR_ENDPOINT =
  runtimeErrorEndpointEnv === 'disabled'
    ? ''
    : runtimeErrorEndpointEnv ||
      (process.env.NODE_ENV === 'production' ? '/api/runtime-errors' : '');

export const normalizeError = (value) => {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack ?? '',
    };
  }

  if (typeof value === 'string') {
    return { message: value };
  }

  if (value && typeof value === 'object') {
    try {
      return { message: JSON.stringify(value) };
    } catch {
      return { message: String(value) };
    }
  }

  return { message: value == null ? 'Unknown runtime error' : String(value) };
};

const createPayloadBase = () => {
  const hasWindow = typeof window !== 'undefined';

  return {
    timestamp: new Date().toISOString(),
    path: hasWindow ? window.location.pathname : 'unknown',
    hash: hasWindow ? window.location.hash : '',
    href: hasWindow ? window.location.href : 'unknown',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
  };
};

export const buildRuntimeErrorPayload = (type, details = {}) => {
  return {
    ...createPayloadBase(),
    type,
    details,
  };
};

const sendToEndpoint = (payload) => {
  if (!RUNTIME_ERROR_ENDPOINT || typeof window === 'undefined') {
    return;
  }

  if (typeof fetch !== 'function') {
    return;
  }

  void fetch(RUNTIME_ERROR_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {});
};

export const reportRuntimeError = (payload) => {
  if (process.env.NODE_ENV !== 'test') {
    // eslint-disable-next-line no-console
    console.error('[runtime-error]', payload);
  }

  sendToEndpoint(payload);
};

export const registerGlobalRuntimeErrorHandlers = () => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const onWindowError = (event) => {
    reportRuntimeError(
      buildRuntimeErrorPayload('window.error', {
        message: event.message,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
        error: normalizeError(event.error),
      })
    );
  };

  const onUnhandledRejection = (event) => {
    reportRuntimeError(
      buildRuntimeErrorPayload('window.unhandledrejection', {
        reason: normalizeError(event.reason),
      })
    );
  };

  window.addEventListener('error', onWindowError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);

  return () => {
    window.removeEventListener('error', onWindowError);
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
  };
};
